import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SpSubdivisionNameCreatableInterface } from '../interfaces/sp-subdivision-name-creatable.interface';
import { SpSubdivisionNameDto } from './sp-subdivision-name.dto';

export class SpSubdivisionNameCreateDto
  extends IntersectionType(
    PickType(SpSubdivisionNameDto, ['spName', 'subdivisionId', 'builderId']),
    PartialType(PickType(SpSubdivisionNameDto, ['active'])),
  )
  implements SpSubdivisionNameCreatableInterface {}
